<template>
	<header>
		<div class="logo"></div>
		<span>{{artist}}</span>
		<div class="nav">
			<nav class="links" v-show="nav">
				<router-link to="home">Home</router-link>
				<router-link to="music">Music</router-link>
				<router-link to="tour">Tour</router-link>
				<router-link to="about">About</router-link>			
			</nav>
			<div class="m-bottomNav">
				<button @click="toggleNav" class="m-navButton left">
					<svg viewBox="0 0 24 24">
						<use id="menu" href="./mdicons.svg#menu"></use>
					</svg>
				</button>
				<nav class="social">
					<a v-for="link in links" v-if="link.url" :href="link.url" class="social">
						<svg viewBox="0 0 24 24">
							<use :id="link.name" :href="`./icons.svg#${link.name}`"></use>
						</svg>
					</a>
				</nav>
				<button class="m-navButton right">
				</button>
			</div>
		</div>
	</header>
</template>
<script>
export default {
	name: "Header",
	data(){
		let {artist, social} = this.$parent.$data
		let {facebook, instagram, twitter, youtube} = social
		return {
			artist,
			links: [
				{
					name: "facebook",
					url: (facebook ? `https://facebook.com/${facebook}` : false)
				},
				{
					name: "instagram",
					url: (instagram ? `https://instagram.com/${instagram}` : false)
				},
				{
					name: "twitter",
					url: (twitter ? `https://twitter.com/${twitter}` : false)
				},
				{
					name: "youtube",
					url: (youtube ? `https://youtube.com/channel/${youtube}` : false)
				}
			],
			nav: (window.innerWidth > 1440 ? true : false)
		}
	},
	methods: {
		toggleNav() {
			this.nav = !this.nav
		}
	}
}
</script>
<style lang="stylus" scoped>
	header
		font-family: "Arial"
		padding: 12.5px 0
		span
			font-size: 24px
			line-height: 25px
			text-align: center
			display: block
			padding: 12.5px
		div.nav
			display: block
			min-width: fit-content
		a
			display: inline-block
			height: 15px
			padding: 5px
		nav.links
			display: grid
			justify-content: center
			grid-template-rows: repeat(auto-fit, 50px)
			grid-template-columns: 90%
			text-align: center
			height: 100vh
			background: white
			position: absolute
			vertical-align: center
			width: 100vw
			top: 0
			a 
				height: 40px
				font-size: 25px
		nav.social
			display: grid
			grid-template-columns: repeat(auto-fit, 25px)
			float: none
			height: 25px
			padding: 0
			justify-content: center
			grid-gap: 5px
			a
				width: 25px
				height: 25px
				padding: 0
				display: inline-block
				svg
					width: 25px
					height: 25px
					display: inline-block
					fill: currentColor !important
					#instagram
						fill: none
						stroke: currentColor
						stroke-width: 2
						stroke-linecap: round
						stroke-linejoin: round
						color: #E4405F
					#facebook
						color: #3B5998
					#twitter
						color: #1DA1F2

		.logo
			width: 75px
			height: 75px
			background-color: black
			display: block
			margin: 0 auto
			border-radius: 50%
			background: url("../assets/logo.svg")
			background-position: center
			background-size: contain
	.m-bottomNav
		position: fixed
		bottom: 0
		width: 100%
		padding: 12.5px
		box-sizing: border-box
		height: 50px
		.m-navButton
			display: inline-block
			height: 25px
			width: 25px
			padding: 0.5px
			margin: 0
			border: 0
			background: transparent
			svg
				width: 24px
				height: 24px
		.m-navButton.left
			float: left
		.m-navButton.right
			float: right		

@media screen and (min-width: 1440px)
	[class|=m]
		display: none !important
	.m-bottomNav
		display: contents !important
	header
		height: 75px
		font-family: "Arial"
		span
			padding: 25px 15px
			font-size: 24px
			line-height: 25px
			display: inline-block
			position: absolute
			top: 12.5px
		div.nav
			display: inline-block
			padding: 0 12.5px
			float: right
		a
			display: inline-block
			height: 15px
			padding: 5px
		nav.social
			display: inline-grid
			grid-template-columns: repeat(auto-fit, 37.5px)
			grid-template-rows: 37.5px
			float: none
			height: 37.5px
			padding: 0
			justify-content: center
			grid-gap: 5px
			width: 100%
			a
				width: 100%
				height: 100%
				padding: 0
				display: inline-block
				svg
					width: 95%
					height: 95%
					display: inline-block
					fill: currentColor !important
					padding: 1px
					#instagram
						fill: none
						stroke: currentColor
						stroke-width: 2
						stroke-linecap: round
						stroke-linejoin: round
						color: #E4405F
					#facebook
						color: #3B5998
					#twitter
						color: #1DA1F2
		nav.links
			grid-template-columns: repeat(4, auto)
			grid-template-rows: 37.5px
			grid-gap: 5px
			width: min-content
			height: 37.5px
			position: initial
			a 
				height: 90%
				padding: 5%
		.logo
			width: 75px
			height: 75px
			background-color: black
			display: inline-block
			clear: both
</style>
